import "./NavBar.scss";

import { Link, NavLink, useNavigate } from "react-router-dom";

import React, { useCallback, useContext, useEffect, useState } from "react";
import KystdatahusetLogo from "../Logo/KystdatahusetLogo";
import {
  RequireLogin,
  AuthContext,
  RequireAnonymous,
} from "../../auth-components/AuthLib";

export function NavBar() {
  const [authState, authDispatch] = useContext(AuthContext);
  const [navOpen, setNavOpen] = useState(false);
  const navigate = useNavigate();
  const { authenticated = false } = authState;
  const [doLogout, setDoLogout] = useState(false);

  const logout = useCallback(() => {
    authDispatch({
      action: "logout",
    });
    setDoLogout(true);
  }, [authDispatch]);

  useEffect(() => {
    if (authenticated === false && doLogout) {
      setDoLogout(false);
      navigate("/logginn", { state: { test: "test" } });
    }
  }, [authenticated, navigate, doLogout, setDoLogout]);

  return (
    <div className="nav">
      <NavLink to="/" className="nav--logo">
        <KystdatahusetLogo height={70} />
      </NavLink>
      <div className="nav--menu">
        <input
          type="checkbox"
          className="nav--hamburger"
          onClick={() => setNavOpen(!navOpen)}
        />
        <div className="nav--items">
          <div className="nav--menu-links">
            <NavLink to="/">Hjem</NavLink>
            <RequireLogin>
              <Link to="/tallogstatistikk">Tall og statistikk</Link>
              <a href="https://kystinfo.no/" target="_blank" rel="noreferrer">
                Kystinfo
              </a>
              <a
                href="http://data.kystverket.no"
                target="_blank"
                rel="noreferrer"
              >
                Data og tjenester
              </a>
            </RequireLogin>
            <NavLink to="/artikkel/om-kystdatahuset">Om kystdatahuset</NavLink>
            <NavLink to="/artikkel/api-tilgang">Data API</NavLink>
            <RequireLogin>
              <Link to="/artikkel/hjelp">Hjelp</Link>
              <Link to="/" onClick={logout}>
                Logg ut
              </Link>
            </RequireLogin>
            <RequireAnonymous authenticated={false}>
              <Link to="/logginn">Logg inn</Link>
            </RequireAnonymous>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavBar;

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar));
